module.exports = __webpack_public_path__ + "img/close-circle.80b4c8aa.svg";